import httpService from "./http.service"

const commentService = {
  getComments: async ({ limit = 500, offset = 0, signal } = {}) => {
    const { data } = await httpService.get("api/comments/", {
      params: { limit, offset },
      signal,
    })
    return data
  },
  getCommentsManagement: async ({
    limit = 2000,
    offset = 0,
    signal,
    withTotal = false,
    qId,
    qRating,
    qAuthor,
    qAuthorStatus,
    qRecordId,
    qRecordService,
    qRecordMaster,
    qRecordDatetime,
    recordDateFrom,
    recordDateTo,
    createdFrom,
    createdTo,
    scope,
    sort,
    sortDir,
  } = {}) => {
    const params = { limit, offset }
    if (withTotal) params.with_total = 1
    if (qId) params.q_id = qId
    if (qRating) params.q_rating = qRating
    if (qAuthor) params.q_author = qAuthor
    if (qAuthorStatus) params.q_author_status = qAuthorStatus
    if (qRecordId) params.q_record_id = qRecordId
    if (qRecordService) params.q_record_service = qRecordService
    if (qRecordMaster) params.q_record_master = qRecordMaster
    if (qRecordDatetime) params.q_record_datetime = qRecordDatetime
    if (recordDateFrom) params.record_date_from = recordDateFrom
    if (recordDateTo) params.record_date_to = recordDateTo
    if (createdFrom) params.created_from = createdFrom
    if (createdTo) params.created_to = createdTo
    if (scope) params.scope = scope
    if (sort) params.sort = sort
    if (sortDir) params.sort_dir = sortDir
    const { data } = await httpService.get("api/comments/management/", {
      params,
      signal,
    })
    return data
  },
  getCommentById: async (commentId) => {
    const { data } = await httpService.get(`api/comments/comment/${commentId}/`)
    return data
  },
  createCommentManagement: async (payload) => {
    const { data } = await httpService.post("api/comments/management/", payload)
    return data
  },
  updateComment: async (commentId, payload) => {
    const { data } = await httpService.patch(`api/comments/comment/${commentId}/`, payload)
    return data
  },
  deleteComment: async (commentId) => {
    const { data } = await httpService.delete(`api/comments/comment/${commentId}/`)
    return data
  },
  deleteCommentsBulk: async (ids) => {
    const { data } = await httpService.post("api/comments/bulk-delete/", { ids })
    return data
  },
  getCommentsByUserId: async (userId) => {
    const { data } = await httpService.get("api/comments/comments-by-user/" + userId)
    return data
  },
  getCommentsByClientId: async (clientId) => {
    const { data } = await httpService.get(
      "api/comments/comments-by-client/" + clientId
    )
    return data
  },
  createComment: async (clientId, userId, recordId, content, rating) => {
    return await httpService.post("api/comments/", {
      clientId,
      userId,
      recordId,
      content,
      rating,
    })
  },
  createFeedback: async (name, email, content) => {
    await httpService.post("api/comments/feedback", {
      name,
      email,
      content,
    })
  },
  UploadCommentImage: async (commentId, formData) => {
    await httpService.patch("api/comments/image/" + commentId, formData)
  },
}

export default commentService
